import React, { useState, useRef } from "react";
import "./LogsScreen.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  usePortalTranslation,
  TranslationEnum,
} from "../../../../../../../providers/TranslationProvider";
import { fetchAndDownloadReport } from "../../../../../../../services/reportService";
import {
  constColorMapping,
  constantMapping,
} from "../../../../../../logsAndReports/constant";
import { LogRowProps } from "../../../../../../logsAndReports/reportAndLogsRowTypes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import excelLogo from "../../../../../../../assets/image/png/excelLogo.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CUR_COMPONENT = "Report And Logs";
const CUR_COMPONENT_COMMON = "commonPortal";
const StudioLogsRow = (props: LogRowProps) => {
  const { translate } = usePortalTranslation();
  const [show, setShow] = useState(false);
  const reportLink = useRef<HTMLAnchorElement | null>(null);
  const downloadFileLink = useRef<HTMLAnchorElement | null>(null);


  const downloadFileHandler = () => {
    const url = props.statusReport;
    fetchAndDownloadReport(url);
  };

  function ErrorLog() {
    if (props.summary && props.description) {
      return <>{<h5>{props.summary}</h5> && <h6>{props.description}</h6>}</>;
    } else {
      return (
        <>
          {
            <h5>
              {" "}
              {translate(
                TranslationEnum.common_portal,
                "No Data Available"
              )}{" "}
            </h5>
          }
        </>
      );
    }
  }

  return (
    <>
      <div className="logs-row">
        <div className="right-elements">
          <div className="logs-heading">
            <div className="log-index">{props.logIndex}.</div>
            <div className="logs-entity-name">
              <p>
                {" "}
                {translate(
                  TranslationEnum.report_and_logs,
                  props.entityName
                )}{" "}
              </p>
            </div>

            <div className="image-excel">
              <img src={excelLogo}></img>
            </div>
            <div
              className={`status ${props.status === 200 ? "success" : "error"}`}
            >
              {props.status === 200 ? (
                <>
                  <CheckCircleIcon
                    style={{ color: "green", height: "12px", width: "12px" }}
                  />
                  Sucess
                </>
              ) : (
                <>
                  <CancelIcon
                    style={{ color: "#C44C36", height: "12px", width: "12px" }}
                  />
                  Failure
                </>
              )}
            </div>
          </div>
          <div className="logs-last-modified-time">
            <p className="last-modified-time">{props.lastModifiedTime}</p>
          </div>
        </div>
        <div className="left-elements">
          {props.status !== 200 && (
            <div className="show-log-btn" onClick={() => setShow(!show)}>
              <div className="log-toggle">
                {translate(TranslationEnum.report_and_logs, "Show Logs")}
                {show ? (
                  <ExpandLessIcon
                    style={{ color: "#227C9D", fontSize: "13px" }}
                  />
                ) : (
                  <ExpandMoreIcon
                    style={{ color: "#227C9D", fontSize: "13px" }}
                  />
                )}
              </div>
            </div>
          )}
          <div>
            <button
              className="download-file-btn-temp"
              onClick={downloadFileHandler}
            >
              <FontAwesomeIcon
                icon={faDownload}
                style={{ marginRight: "5px" }}
              />
              {translate(TranslationEnum.report_and_logs, "Status Report")}
            </button>
            <a href="/#" ref={downloadFileLink} hidden>
              download link
            </a>
          </div>
        </div>
      </div>
      <div className="collapse-show">{show && <ErrorLog />}</div>
    </>
  );
};

export default StudioLogsRow;
